import * as yup from 'yup';
import { createCompanyDepartmentFormFields } from '../../fields/formFields/createCompanyDepartment';

export const createCompanyDepartmentSchema = yup.object({
  [createCompanyDepartmentFormFields.name]: yup
    .string()
    .max(150, 'Name must be at most 150 characters')
    .required('Name is required')
    .trim(),
  [createCompanyDepartmentFormFields.description]: yup
    .string()
    .max(500, 'Description must be at most 500 characters')
    .required('Description is required')
    .trim(),
});
